var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3754_56697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5208 22.3333H4.1875C1.87879 22.3333 0 20.4545 0 18.1458V4.1875C0 1.87879 1.87879 0 4.1875 0H26.5208C28.8295 0 30.7083 1.87879 30.7083 4.1875V18.1458C30.7083 20.4545 28.8295 22.3333 26.5208 22.3333ZM4.1875 2.79167C3.41979 2.79167 2.79167 3.417 2.79167 4.1875V18.1458C2.79167 18.9163 3.41979 19.5417 4.1875 19.5417H26.5208C27.2885 19.5417 27.9167 18.9163 27.9167 18.1458V4.1875C27.9167 3.417 27.2885 2.79167 26.5208 2.79167H4.1875Z",
    fill: "#7EB250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5208 67.0013H4.1875C1.87879 67.0013 0 65.1225 0 62.8138V32.1055C0 29.7968 1.87879 27.918 4.1875 27.918H26.5208C28.8295 27.918 30.7083 29.7968 30.7083 32.1055V62.8138C30.7083 65.1225 28.8295 67.0013 26.5208 67.0013ZM4.1875 30.7096C3.41979 30.7096 2.79167 31.335 2.79167 32.1055V62.8138C2.79167 63.5843 3.41979 64.2096 4.1875 64.2096H26.5208C27.2885 64.2096 27.9167 63.5843 27.9167 62.8138V32.1055C27.9167 31.335 27.2885 30.7096 26.5208 30.7096H4.1875Z",
    fill: "#7EB250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8118 67.0013H40.4785C38.1698 67.0013 36.291 65.1225 36.291 62.8138V48.8555C36.291 46.5468 38.1698 44.668 40.4785 44.668H62.8118C65.1206 44.668 66.9993 46.5468 66.9993 48.8555V62.8138C66.9993 65.1225 65.1206 67.0013 62.8118 67.0013ZM40.4785 47.4596C39.7108 47.4596 39.0827 48.085 39.0827 48.8555V62.8138C39.0827 63.5843 39.7108 64.2096 40.4785 64.2096H62.8118C63.5796 64.2096 64.2077 63.5843 64.2077 62.8138V48.8555C64.2077 48.085 63.5796 47.4596 62.8118 47.4596H40.4785Z",
    fill: "#7EB250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8118 39.0833H40.4785C38.1698 39.0833 36.291 37.2045 36.291 34.8958V4.1875C36.291 1.87879 38.1698 0 40.4785 0H62.8118C65.1206 0 66.9993 1.87879 66.9993 4.1875V34.8958C66.9993 37.2045 65.1206 39.0833 62.8118 39.0833ZM40.4785 2.79167C39.7108 2.79167 39.0827 3.417 39.0827 4.1875V34.8958C39.0827 35.6663 39.7108 36.2917 40.4785 36.2917H62.8118C63.5796 36.2917 64.2077 35.6663 64.2077 34.8958V4.1875C64.2077 3.417 63.5796 2.79167 62.8118 2.79167H40.4785Z",
    fill: "#7EB250"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3754_56697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature9);
export default __webpack_public_path__ + "static/media/feature9.87f20660d9bf264c9364a4b27d12b75b.svg";
export { ForwardRef as ReactComponent };